// @flow
import { useField } from "formik";
import * as React from "react";
import ErrorLabel from "ui/atoms/ErrorLabel";
import PhoneField from "ui/molecules/PhoneFieldAlt";

type Props = {
  name: string,
};

function FormikPhoneField({ name, ...rest }: Props): React.Node {
  const [field, meta, helpers] = useField(name);

  return (
    <div>
      <PhoneField
        {...rest}
        country="US"
        name={field.name}
        onBlur={field.onBlur}
        onChange={(value) => helpers.setValue(value)}
        value={field.value}
      />
      <ErrorLabel>{meta.touched && meta.error}</ErrorLabel>
    </div>
  );
}

export default FormikPhoneField;
